
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 22.5h-17A.5.5 0 013 22V2a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v20a.5.5 0 01-.5.5zM4 21.5h16v-19H4z"}}),_c('path',{attrs:{"d":"M23.5 22.5H.5a.5.5 0 010-1h23a.5.5 0 010 1zM10.25 7h-2.5a.5.5 0 010-1h2.5a.5.5 0 010 1zm0 5h-2.5a.5.5 0 010-1h2.5a.5.5 0 010 1zm0 5h-2.5a.5.5 0 010-1h2.5a.5.5 0 010 1zm6-10h-2.5a.5.5 0 010-1h2.5a.5.5 0 010 1zm0 5h-2.5a.5.5 0 010-1h2.5a.5.5 0 010 1zm0 5h-2.5a.5.5 0 010-1h2.5a.5.5 0 010 1z"}})])
          )
        }
      }
    